export function newView(sub, query, limit) {
    return { sub, query, limit, ids: [], total: 0, badge: 0, version: 0, status: "loading", error: null };
}
/**
 * Apply one server message to a view. Pure; returns the same object when
 * nothing changed. The server's `index` is authoritative: enter/update mean
 * "this issue is now at position index in the window".
 */
export function applyViewMessage(v, msg) {
    switch (msg.t) {
        case "snapshot":
            return {
                view: { ...v, ids: msg.issues.map((i) => i.id), total: msg.total, badge: 0, version: msg.version, status: "live", error: null },
                issues: msg.issues,
            };
        case "enter":
        case "update": {
            const ids = v.ids.filter((id) => id !== msg.issue.id);
            ids.splice(Math.min(msg.index, ids.length), 0, msg.issue.id);
            return { view: { ...v, ids, version: msg.version }, issues: [msg.issue] };
        }
        case "exit": {
            if (!v.ids.includes(msg.id))
                return { view: { ...v, version: msg.version }, issues: [] };
            return { view: { ...v, ids: v.ids.filter((id) => id !== msg.id), version: msg.version }, issues: [] };
        }
        case "meta":
            return { view: { ...v, total: msg.total, badge: msg.badge, version: msg.version }, issues: [] };
        case "resync":
            // Keep showing the old window until the new snapshot lands.
            return { view: { ...v, status: "loading" }, issues: [] };
        case "error":
            return { view: { ...v, status: "error", error: msg.message }, issues: [] };
        default:
            return { view: v, issues: [] };
    }
}
/**
 * Local estimate after an optimistic change: does `issueId` still belong in
 * this window, and where? `cmp` orders two ids by the view's sort. The server's
 * next message for this issue overrides the estimate.
 */
export function localAdjust(v, issueId, matches, cmp) {
    const was = v.ids.indexOf(issueId);
    if (!matches) {
        if (was < 0)
            return v;
        return { ...v, ids: v.ids.filter((id) => id !== issueId), total: Math.max(0, v.total - 1) };
    }
    const rest = was < 0 ? v.ids : v.ids.filter((id) => id !== issueId);
    let pos = 0;
    while (pos < rest.length && cmp(rest[pos], issueId) <= 0)
        pos++;
    if (was < 0) {
        if (pos >= v.limit)
            return v; // would land outside the window; the server's badge will say so
        const ids = [...rest];
        ids.splice(pos, 0, issueId);
        return { ...v, ids, total: v.total + 1 };
    }
    if (pos === was)
        return v;
    const ids = [...rest];
    ids.splice(pos, 0, issueId);
    return { ...v, ids };
}
//# sourceMappingURL=views.js.map